import * as S from './styles';

const Appointments: React.FC = () => (
  <S.Container>
    <h1>Meus Agendamentos</h1>
  </S.Container>
);

export default Appointments;
